import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarSegmentosDs, criarLogradouroDs } from "../../DataSources";

const localStorageKey = "cadastroSegmentosGridState";

let _segmentoCorrente = undefined;

export default class SegmentosBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("segmentos/editar/" + e.data.id);
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="Segmentos" novoCb={this.novoSegmento.bind(this)}>
                        <DataGrid
                            ref={grid => this._gridInstance = grid}
                            dataSource={criarSegmentosDs()}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            remoteOperations={true}
                            columnAutoWidth={true}
                            columnHidingEnabled={true}
                            focusedRowEnabled={true}
                            wordWrapEnabled={window.innerWidth < 800}
                            filterSyncEnabled={true}
                            onEditingStart={this.onAtualizandoRow}>
                            <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                            <FilterRow visible={true} />
                            <Editing allowDeleting={true} allowUpdating={true} mode />
                            <Column dataField={'id'} caption={"#"} alignment={'center'} allowEditing={false} />
                            <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                                <FormItem visible={false}></FormItem>
                            </Column>
                            <Column dataField={'logradouroId'} caption={"Logradouro"}>
                                <Lookup
                                    dataSource={criarLogradouroDs}
                                    valueExpr={"id"}
                                    displayExpr={"nome"} />
                            </Column>
                            <Column dataField={'descricao'} caption={"Descrição"} />
                            <Column dataField={'codigo'} caption={"Cod. Segmento"} />
                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    novoSegmento() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("segmentos/novo");
    }

}
